import type { UnifiedTemplate } from './types';

const EXCLUDED_APPOINTMENT_REPORT_STATUSES = new Set(['missed', 'no_show', 'cancelled']);

export type AttendanceCardGpaDisplayMode = 'consolidated' | 'individual_appointments';

const INDIVIDUAL_GPA_DISPLAY_MODE_VALUES = new Set([
  'individual',
  'individual_appointments',
  'individual-appointments',
  'all_appointments',
  'all-appointments',
]);

export function normalizeOperationsReportStatus(status: unknown): string {
  if (status === null || status === undefined) {
    return '';
  }

  return String(status)
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');
}

export function normalizeAttendanceCardGpaDisplayMode(mode: unknown): AttendanceCardGpaDisplayMode {
  const normalizedMode = normalizeOperationsReportStatus(mode);
  return INDIVIDUAL_GPA_DISPLAY_MODE_VALUES.has(normalizedMode)
    ? 'individual_appointments'
    : 'consolidated';
}

export function resolveAttendanceCardGpaDisplayMode(
  template?: Pick<UnifiedTemplate, 'sections'> | null,
): AttendanceCardGpaDisplayMode {
  if (!template?.sections || template.sections.length === 0) {
    return 'consolidated';
  }

  const configuredSection = template.sections.find((section) =>
    section?.type === 'section_fields'
    && section.config?.sectionKey === 'overview'
    && section.config?.gpaDisplayMode !== undefined,
  ) || template.sections.find((section) => section?.config?.gpaDisplayMode !== undefined);

  return normalizeAttendanceCardGpaDisplayMode(configuredSection?.config?.gpaDisplayMode);
}

export function shouldIncludeAppointmentInOperationsReport(status: unknown): boolean {
  return !EXCLUDED_APPOINTMENT_REPORT_STATUSES.has(normalizeOperationsReportStatus(status));
}